import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'common/libs/redux-persist/storage';

import accountInfo from 'modules/general/my-account/account-info/reducers/accountInfoReducer';
import termsAndCondition from 'modules/general/shared/reducers/termsAndConditionReducer';
import auth from 'modules/general/shared/reducers/authReducer';

const authPersistConfig = {
  key: 'auth',
  storage,
  throttle: 200,
};

export default combineReducers({
  auth: persistReducer(authPersistConfig, auth),
  accountInfo,
  termsAndCondition,
});
